// lib
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

// elvispos
import { ElvisDSModule } from 'ngx-elvis-ds';
import { ProductCardComponent } from './product-card/product-card.component';
import { ProductItemComponent } from './product-item/product-item.component';
import { TenderCardComponent } from './tender-card/tender-card.component';
import { UnDrawImgComponent } from './undraw-img/undraw-img.component';
import { CartComponent } from './cart/cart.component';
import { SideMenuComponent } from './side-menu/side-menu.component';
import { ClockComponent } from './clock/clock.component';
import { SectionHeaderComponent } from './section-header/section-header.component';
import { DenominationCardComponent } from './denomination-card/denomination-card.component';
import { PopQtySelectComponent } from './pop-qty-select/pop-qty-select.component';
import { MenuSelectComponent } from './menu-select/menu-select.component';
import { CalculatorComponent } from './calculator/calculator.component';
import { FormsModule } from '@angular/forms';
import { TouchScrollFixDirective } from './touch-scroll-fix/touch-scroll-fix.directive';

@NgModule({
    declarations: [
        ClockComponent,
        ProductCardComponent,
        ProductItemComponent,
        TenderCardComponent,
        UnDrawImgComponent,
        CartComponent,
        SideMenuComponent,
        SectionHeaderComponent,
        DenominationCardComponent,
        PopQtySelectComponent,
        MenuSelectComponent,
        CalculatorComponent,
        TouchScrollFixDirective
    ],
    imports: [
        CommonModule,
        IonicModule,
        ElvisDSModule,
        FormsModule
    ],
    exports: [
        ClockComponent,
        ProductCardComponent,
        ProductItemComponent,
        TenderCardComponent,
        UnDrawImgComponent,
        CartComponent,
        SideMenuComponent,
        SectionHeaderComponent,
        DenominationCardComponent,
        PopQtySelectComponent,
        MenuSelectComponent,
        CalculatorComponent,
        TouchScrollFixDirective
    ]
})
export class GUIBaseModule { }
